export default "__VITE_ASSET__Dg72fRc1__"